import { useContext } from 'react';
import { Box, Drawer, styled, useMediaQuery, useTheme } from '@mui/material';
import { MenuToggleContext } from '@/base/layouts/contexts/MenuToggleContext';
import { InnerMenu } from './InnerMenu/InnerMenu';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        min-height: 100vh;
        background: ${theme.sidebar.background};
        box-shadow: ${theme.sidebar.boxShadow};
        position: relative;
        z-index: 7;
        padding: ${theme.spacing(3.56, 2.67, 2.67, 2.67)};

`
);

function Sidebar() {
  const theme = useTheme();
  const { isMenuOpen, closeMenu } = useContext(MenuToggleContext);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box gridArea="Sidebar">
      {
        <SidebarWrapper
          sx={{
            display: {
              xs: 'none',
              lg: 'inline-block'
            },
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0
          }}
          display="flex"
          justifyContent="space-between"
        >
          <InnerMenu />
        </SidebarWrapper>
      }

      {!isMobile && !isDesktop && (
        <Drawer
          sx={{
            boxShadow: `${theme.sidebar.boxShadow}`
          }}
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={isMenuOpen}
          onClose={closeMenu}
          variant="temporary"
          elevation={9}
        >
          <SidebarWrapper>
            <InnerMenu />
          </SidebarWrapper>
        </Drawer>
      )}
    </Box>
  );
}

export default Sidebar;
